export const COMMANDE_ORIGINE_MAGASIN = 'magasin';
export const COMMANDE_ORIGINE_EN_LIGNE = 'en_ligne';

export const COMMANDE_ORIGINE_OPTIONS = [
  { value: COMMANDE_ORIGINE_MAGASIN, label: 'Magasin' },
  { value: COMMANDE_ORIGINE_EN_LIGNE, label: 'Commande en ligne' },
];

/** @param {unknown} order */
export function isCommandeEnLigne(order) {
  const v = order?.commande_origine;
  return String(v || '').trim().toLowerCase() === COMMANDE_ORIGINE_EN_LIGNE;
}

/** Ville tag for commande en ligne (from store join or store_id heuristics). */
export function getOrderVilleLabel(order) {
  if (!order) return '';
  const city = String(order.store_city || '').trim();
  const name = String(order.store_name || '').trim();
  const blob = `${city} ${name}`.toLowerCase();
  if (blob.includes('casa') || blob.includes('casablanca')) return 'Casa';
  if (blob.includes('mekn')) return 'Meknès';
  if (city) return city;
  if (name) return name;
  const sid = Number(order.store_id);
  if (sid === 1) return 'Casa';
  if (sid === 2) return 'Meknès';
  return '';
}
